import styled from 'styled-components';
import Layout from 'antd/lib/layout';
import Select from 'antd/lib/select';
import { Link } from 'react-router-dom';

const { Content } = Layout;

export const DatasetPage = styled(Content)`
  margin: 0 auto;
  max-width: 1000px;
  padding: 16px;
  width: 100%;
`;

export const DatasetHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;

  @media (max-width: 900px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  color: #1b2b43;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.15;
  margin: 0;

  @media (max-width: 900px) {
    font-size: 36px;
  }
`;

export const HeaderActions = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;

  @media (max-width: 900px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const SearchInput = styled.div`
  flex: 0 0 320px;
  width: 320px;

  @media (max-width: 900px) {
    flex: 1 1 100%;
    width: 100%;
  }
`;

export const Toolbar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

export const SortSelect = styled(Select)`
  flex: 0 0 230px;
  min-width: 230px;
`;

export const DatasetList = styled.div`
  border: 1px solid #d8e0ec;
  border-radius: 8px;
  overflow: hidden;
`;

export const ZeroState = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 36px 20px;
  text-align: center;
`;

export const ZeroStateTitle = styled.h3`
  color: #1b2b43;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

export const ZeroStateDescription = styled.p`
  color: #4c5a6d;
  font-size: 14px;
  margin: 0;
`;

export const ZeroStateActions = styled.div`
  margin-top: 4px;
`;

export const DatasetItem = styled.div`
  align-items: stretch;
  background: #fff;
  border-left: 4px solid transparent;
  border-bottom: 1px solid #e8edf5;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 18px 20px;

  &:last-child {
    border-bottom: 0;
  }
`;

export const DatasetContent = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
`;

export const DatasetName = styled(Link)`
  color: #1b2b43;
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 6px;

  &:hover {
    color: #1b2b43;
    text-decoration: underline;
  }
`;

export const DatasetDescription = styled.p`
  color: #344154;
  font-size: 14px;
  margin: 0 0 10px;
`;

export const DatasetMeta = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: auto;
  width: 100%;
`;

export const LastUpdatedText = styled.span`
  color: #4c5a6d;
  font-size: 12px;
  white-space: nowrap;
  text-align: right;
`;

export const ActionsRow = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  padding-top: 4px;

  .ant-btn {
    height: 36px;
    width: 36px;
    padding: 0;
  }

  .anticon {
    font-size: 14px;
  }
`;

export const ActionsColumn = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
`;
